import React from "react";

const TakeNow = () => {
  return (
    <svg
      width="33"
      height="23"
      viewBox="0 0 33 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.82465"
        y="2.18793"
        width="30.3825"
        height="19.1373"
        rx="2.44669"
        stroke="#023A4A"
        strokeWidth="1.6493"
      />
      <rect
        x="10.3661"
        y="6.2768"
        width="11.2997"
        height="10.6182"
        rx="5.30911"
        stroke="#023A4A"
        strokeWidth="1.6493"
      />
      <rect
        x="4.7707"
        y="0.681529"
        width="3.40764"
        height="1.36306"
        rx="0.681529"
        stroke="#023A4A"
        strokeWidth="1.36306"
      />
    </svg>
  );
};

export default TakeNow;
